__turbopack_context__.v({
  "className": "roboto_condensed_6f05eee-module__mqXGhG__className",
});
